<template>
  <!-- 支付设置 -->
  <div class="game_box">
    <div class="game_title">{{ $t("gameinfo.pay.paysetting") }}</div>
    <div class="xian"></div>
    <div class="loading_box" v-if="!paySecret"><loading></loading></div>

    <div class="game" v-else>
      <div class="basic">
        <div class="BASIC MG_t53">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              {{ $t("gameinfo.pay.paytoken") }}
            </div>
            <div class="time_text">
              <span @click="copy(paySecret)">*************</span>
              <span class="CU showbtn showSecret" @click="copy(paySecret)">{{
                $t("gameinfo.pay.copy")
              }}</span>
            </div>
            <div class="init_title">{{ $t("gameinfo.pay.dataTokeninfo") }}</div>
          </div>
        </div>

        <div class="BASIC MG_t53">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              <span class="must">*</span>
              {{ $t("gameinfo.pay.url") }}
            </div>
            <input
              type="text"
              style="height: 40px"
              class="TGA_INPUT TGA_PD"
              v-model="site"
              @blur.prevent="changeCount()"
              :placeholder="$t('gameinfo.pay.url')"
            />
          </div>
        </div>
        <div
          class="btn CU"
          @click="payCallback"
          :class="BTN ? '' : 'btn_active'"
        >
          {{ $t("gameinfo.pay.save") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import loading from "@/components/loading/loading.vue";
export default {
  components: {
    loading,
  },
  data() {
    return {
      appId: this.$route.query.appId,
      gameId: this.$route.query.gameId,
      site: "",
      paySecret: "",
      BTN: false,
      merchantId: "",
    };
  },
  computed: {
    ...mapState("game", ["GameAppInfo"]),
  },
  created() {
    if (!this.GameAppInfo) {
      this.load();
    } else {
    }
    this.getPaySecret();
  },
  methods: {
    ...mapActions("game", [
      "getGameDeveloperInfo",
      "GetPaySecret",
      "SetPayCallback",
    ]),
    async load() {
      await this.getGameDeveloperInfo({
        $axios: this.$axios,
        gameId: this.gameId,
      });
    },
    // 保存回调地址
    async payCallback() {
      if (this.site.match(/^[ ]*$/)) {
        this.$message.error(this.$t("gameinfo.pay.urlkong"));
      }

      var res = await this.SetPayCallback({
        $axios: this.$axios,
        id: this.merchantId,
        callbackUrl: this.site.replace(/\s/g, ""),
      });
      if (res.code == 200) {
        this.$message.success(this.$t("gameinfo.pay.save_success"));
      }
    },

    // 获取支付设置信息
    async getPaySecret() {
      var res = await this.GetPaySecret({
        $axios: this.$axios,
        appId: this.appId,
      });
      if (res.code == 200) {
        this.merchantId = res.data.id;
        this.paySecret = res.data.appSecret;
        this.site = res.data.callbackUrl;
      }
    },
    changeCount() {
      if (this.site) {
        this.BTN = true;
      } else {
        this.BTN = false;
      }
    },

    // 点击复制
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message.info(this.$t("gameinfo.pay.copysuccess"));
      oInput.remove();
    },
  },
};
</script>

<style>
.game_box {
  min-height: 419px;
  width: 100%;
}
.game_title {
  padding-left: 50px;
  font-size: 18px;
  color: #282828;
}
.xian {
  width: 100%;
  height: 1px;
  margin-top: 14px;
  background-color: #f3f3f3;
}
.game {
  margin-top: 31px;
}
.basic {
  padding-left: 175px;
}
.time_text {
  height: 40px;
  line-height: 40px;
}
.MG_t53 {
  margin-top: 53px;
}
.init_title {
  font-size: 12px;
  color: #b0b0b0;
}
.showbtn {
  color: #4990fa;
}
.showSecret {
  margin-left: 30px;
}
.btn {
  margin-top: 30px;
  width: 120px;
  height: 40px;
  background-color: #4990fa;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.paySecret {
  display: inline-block;
  width: 98%;
  word-wrap: break-word;
}
.loading_box {
  height: 419px;
}
</style>



// WEBPACK FOOTER //
// src/components/games/gameinfo/Exploit_settings/pay.vue